import { toast, Toast } from "react-hot-toast";

interface CustomToastProps {
  t: Toast;
  message: string;
  type?: "success" | "error" | "default";
}

export const CustomToast = ({ t, message, type = "default" }: CustomToastProps) => {
  var className = t.visible ? "custom-toast-show" : "custom-toast-hide";
  if (type === "success") {
    className = className ? `${className} custom-toast-success` : "custom-toast-success";
  } else if (type === "error") {
    className = className ? `${className} custom-toast-failed` : "custom-toast-failed";
  } else {
    className = className ? `${className} custom-toast-default` : "custom-toast-default";
  }
  return (
    <div
      role="button"
      tabIndex={0}
      className={`custom-toast ${className}`}
      onClick={() => toast.dismiss(t.id)}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && toast.dismiss(t.id)}
    >
      {message}
    </div>
  );
};
